module.exports = __webpack_public_path__ + "img/10.a4614bdb.jpeg";